import { styled } from 'baseui'
import GroupwareLogo from './GroupwareLogo'

const Wrapper = styled('div', {
  minHeight: '100dvh',
  minWidth: '100dvw',
  display: 'grid',
  placeItems: 'center',
  patting: '24px',
})

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  width: 'clamp(320px, 90vw, 488px)',
  height: 'clamp(500px, 60vh, 520px)',
  gap: 'clamp(8px, 2vw, 20px)',
  padding: '32px',
  border: '1px solid #dadada',

})

const TopSection = styled('div', {
  flexGrow: '1',
})

const BottomSection = styled('div', {
  margin: '0 -8px 12px -8px',
})

const LoginButton = styled('button', {
  width: '100%',
  minHeight: '56px',
  background: 'black',
  color: 'white',
  border: 'none',
  position: 'relative',
  padding: '0',
  cursor: 'pointer',
})

const LoginButtonLogo = styled('span', {
  position: 'absolute',
  left: '20px',
  top: '50%',
  transform: 'translate(0, -50%)',
  width: '24px',
  height: '24px',
})

const LoginButtonLabel = styled('span', {
  fontSize: '16px',
  color: 'white',
})


const LoginCard = ({ cardHeader, onButtonClick, buttonText, showLogo = true }) => {
  return (
    <Wrapper>
      <Container>
        <TopSection>
            {cardHeader}
        </TopSection>
        <BottomSection>
          <LoginButton onClick={onButtonClick}>
            {showLogo && (
              <LoginButtonLogo>
                  <GroupwareLogo />
              </LoginButtonLogo>
            )}
            <LoginButtonLabel>
                {buttonText}
            </LoginButtonLabel>
          </LoginButton>
        </BottomSection>
      </Container>
    </Wrapper>
  )
}

export default LoginCard;

